import { i18n } from 'i18n';
import {
  CreateFlushRecipeCommand,
  FileResponse,
  FlushRecipeDto,
  UpdateFlushRecipeCommand
} from './api';
import {
  makeCreateMutation,
  makeDeleteMutation,
  makeGetQuery,
  makeListQuery,
  makeUpdateMutation
} from './useApi';

const FLUSH_RECIPE_KEY = 'flushRecipe';
export const FLUSH_RECIPES_KEY = 'flushRecipes';

export interface FlushRecipeMutation {
  projectId: string;
  stopeId: string;
  flushRecipeId?: string | null;
  data: CreateFlushRecipeCommand | UpdateFlushRecipeCommand;
}

export const useCreateFlushRecipeMutation = makeCreateMutation<string, FlushRecipeMutation>(
  FLUSH_RECIPES_KEY,
  (api, scenarioId) => (mutation) => api.flushRecipes.create(mutation.projectId, mutation.stopeId, mutation.data, scenarioId),
  () => i18n._('Flush created.'),
);

export const useUpdateFlushRecipeMutation = makeUpdateMutation<void, FlushRecipeMutation>(
  FLUSH_RECIPE_KEY,
  FLUSH_RECIPES_KEY,
  (api) => (mutation) => api.flushRecipes.update(mutation.flushRecipeId ?? '', mutation.data),
  () => i18n._('Flush updated.'),
);

export interface FlushRecipesQueryParams {
  projectId: string;
  stopeId: string;
  scenarioId?: string;
}

export const useFlushRecipesQuery = makeListQuery<FlushRecipesQueryParams, FlushRecipeDto[]>(
  FLUSH_RECIPES_KEY,
  (api, params) => () => api.flushRecipes.getByStope(params.projectId, params.stopeId, params.scenarioId),
);

export const useFlushRecipeQuery = makeGetQuery<FlushRecipeDto, string>(
  FLUSH_RECIPE_KEY,
  (api, entityId) => () => api.flushRecipes.get(entityId),
);

export const useDeleteFlushRecipeMutation = makeDeleteMutation<void, FlushRecipeDto>(
  FLUSH_RECIPE_KEY,
  FLUSH_RECIPES_KEY,
  (api) => (flushRecipe) => api.flushRecipes.delete(flushRecipe.entityId),
  () => i18n._('Flush successfully deleted'),
  (mutation) => mutation.entityId,
);

export const useRestoreFlushRecipeMutation = makeCreateMutation<FileResponse, string>(
  FLUSH_RECIPES_KEY,
  (api) => (flushRecipeId) => api.flushRecipes.restore(flushRecipeId),
  () => i18n._('Flush successfully restored'),
);

export interface AllProjectFlushRecipesQueryParams {
  projectId: string;
  scenarioId?: string;
}

export const useAllProjectFlushRecipesQuery = makeListQuery<AllProjectFlushRecipesQueryParams, FlushRecipeDto[]>(
  FLUSH_RECIPES_KEY,
  (api, params) => () => api.flushRecipes.getAllByProject(params.projectId, params.scenarioId),
);
